import { CircularProgress } from '@mui/material'
import React from 'react'

import ListEditor from '../common/ListEditor'
import useNextSteps from '../hooks/api/useNextSteps'
import SettingsFooter from './shared/SettingsFooter'
import useAlert from '../hooks/useAlert'

const MAX_ALLOWED_NEXT_STEPS = 15

export const NextStepsForm = ({ nextSteps, setNextSteps }) => {
  return (
    <ListEditor
      list={nextSteps}
      editableKeys={[{ label: 'Action', key: 'name' }]}
      onChange={setNextSteps}
      maxLength={MAX_ALLOWED_NEXT_STEPS}
      canReorder
    ></ListEditor>
  )
}

const NextSteps = () => {
  const { nextSteps, setNextSteps, isLoading, hasLoadError, saveNextSteps } =
    useNextSteps()

  const { createAlert, createGenericErrorAlert } = useAlert()
  const onSuccess = () =>
    createAlert({
      severity: 'success',
      message: 'Successfully saved next step actions',
    })

  const onFailure = () => createGenericErrorAlert()

  const submit = () => {
    return saveNextSteps().then(onSuccess).catch(onFailure)
  }

  if (isLoading) return <CircularProgress />

  return (
    <>
      <NextStepsForm nextSteps={nextSteps} setNextSteps={setNextSteps} />
      <SettingsFooter saveButton={{ onClick: submit }} />
    </>
  )
}

export default NextSteps
